import {
    ConnectedProps,
    connectExpressCheckout,
} from './connectExpressCheckout';
import { ExpressCheckout, ExpressCheckoutProps } from './ExpressCheckout';

export type ConnectedExpressCheckoutProps = Omit<
    ExpressCheckoutProps,
    keyof ConnectedProps
>;
export const ConnectedExpressCheckout = connectExpressCheckout(ExpressCheckout);
